<template>
    <div class="row" id="basic-table" :class="sticky">
        <div class="col-12">
            <div class="card" :class="fixedfullscreen">
                <div class="mb-2">
                    <div class="card-text">      
                        <div class="row justify-content-end align-items-center">
                            <div class="col-2 col-md-3 mt-1">
                                <div class="d-flex w-100 justify-content-start align-items-center">
                                    <div class="dropdown">
                                        <button type="button" class="btn btn-sm dropdown-toggle hide-arrow py-0 waves-effect waves-float waves-light p-2 pt-1 pb-1" data-bs-toggle="dropdown">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
                                            Columnas
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-end"> 
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <h5 class="text-center text-green pt-2">Ocultar o mostrar<hr></h5>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-check form-check-inline d-block m-1" v-if="consultantId == ''">
                                                        <input class="form-check-input" type="checkbox" id="column1" value="checked" :checked="column1" @click="showHideColum(1)">
                                                        <label class="form-check-label" for="column1">Consultante</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1" v-if="consultantId == ''">
                                                        <input class="form-check-input" type="checkbox" id="column20" value="checked" :checked="column20" @click="showHideColum(20)">
                                                        <label class="form-check-label" for="column20">WhatsApp</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1" v-if="consultantId == ''">
                                                        <input class="form-check-input" type="checkbox" id="column21" value="checked" :checked="column21" @click="showHideColum(21)">
                                                        <label class="form-check-label" for="column21">Mail</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column2" value="checked" :checked="column2" @click="showHideColum(2)">
                                                        <label class="form-check-label" for="column2">Publicación Contratada</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column3" value="checked" :checked="column3" @click="showHideColum(3)">
                                                        <label class="form-check-label" for="column3">Estado</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column4" value="checked" :checked="column4" @click="showHideColum(4)">
                                                        <label class="form-check-label" for="column4">Opciones</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column5" value="checked" :checked="column5" @click="showHideColum(5)">
                                                        <label class="form-check-label" for="column5">Moneda</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column6" value="checked" :checked="column6" @click="showHideColum(6)">
                                                        <label class="form-check-label" for="column6">Monto Bruto</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column7" value="checked" :checked="column7" @click="showHideColum(7)">
                                                        <label class="form-check-label" for="column7">Descuento</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column8" value="checked" :checked="column8" @click="showHideColum(8)">
                                                        <label class="form-check-label" for="column8">Monto Final</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column9" value="checked" :checked="column9" @click="showHideColum(9)">
                                                        <label class="form-check-label" for="column9">Confirmación de cobro</label>
                                                    </div> 
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column10" value="checked" :checked="column10" @click="showHideColum(10)">
                                                        <label class="form-check-label" for="column10">Fecha Cobro</label>
                                                    </div>  
                                                </div>
                                                <div class="col-md-6">  
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column11" value="checked" :checked="column11" @click="showHideColum(11)">
                                                        <label class="form-check-label" for="column11">Deuda</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column12" value="checked" :checked="column12" @click="showHideColum(12)">
                                                        <label class="form-check-label" for="column12">%</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column13" value="checked" :checked="column13" @click="showHideColum(13)">
                                                        <label class="form-check-label" for="column13">Total Comisión</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column14" value="checked" :checked="column14" @click="showHideColum(14)">
                                                        <label class="form-check-label" for="column14">Total a Cobrar</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column15" value="checked" :checked="column15" @click="showHideColum(15)">
                                                        <label class="form-check-label" for="column15">Fecha</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column16" value="checked" :checked="column16" @click="showHideColum(16)">
                                                        <label class="form-check-label" for="column16">Pendiente a cobrar</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column17" value="checked" :checked="column17" @click="showHideColum(17)">
                                                        <label class="form-check-label" for="column17">ID de contratación</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column18" value="checked" :checked="column18" @click="showHideColum(18)">
                                                        <label class="form-check-label" for="column18">ID de Pago</label>
                                                    </div>
                                                    <div class="form-check form-check-inline d-block m-1">
                                                        <input class="form-check-input" type="checkbox" id="column19" value="checked" :checked="column19" @click="showHideColum(19)">
                                                        <label class="form-check-label" for="column19">ID de Deposito</label>
                                                    </div>
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-10 col-md-9 mt-1">
                                <div class="d-flex justify-content-end align-items-center">
                                    
                                    <div>
                                        <button v-if="billingExport" type="button" class="btn btn-outline-primary hide-arrow waves-effect waves-float waves-light p-3 pb-1 pt-1 me-2 d-flex" @click="exportOption()">
                                            <i class="las la-file-csv"></i> <span class="d-none d-sm-block">Exportar</span>
                                        </button>
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive h-100">
                    <table class="table table-striped position-relative align-middle mb-5">
                        <thead class="fixed-head-table">
                            <tr>
                                <th colspan="1" class="text-center bg-my"></th>
                                <th v-if="title1 > 0" :colspan="title1" class="text-center bg-light-success">Detalle de la consulta</th>
                                <th v-if="title2 > 0" :colspan="title2" class="text-center bg-light-warning">Precio al consultante</th>
                                <th v-if="country == 5" :colspan="1" class="text-center bg-light-warning"></th>
                                <th :colspan="1" class="bg-white shadow-none border-0" v-if="(title1 > 0 || title2 > 0) && (title3 > 0 || title4 > 0)"></th>
                                <th v-if="title3 > 0" :colspan="title3" class="text-center bg-light-primary">Comisiones Animasana</th>
                                <th v-if="title4 > 0" :colspan="title4" class="text-center bg-light-info">Liberación de pagos</th>
                                <th :colspan="1" class="bg-white shadow-none border-0" v-if="(title1 > 0 || title2 > 0 || title3 > 0 || title4 > 0) && (title5 > 0 || title6 > 0 || title7 > 0)"></th>
                                <th v-if="title5 > 0" :colspan="title5" class="text-center bg-light-success"></th>
                                <th v-if="title6 > 0" :colspan="title6" class="text-center bg-light-warning"></th>
                                <th v-if="title7 > 0" :colspan="title7" class="text-center bg-light-primary"></th>   
                            </tr>
                            <tr>
                                <th class="text-center bg-my text-success sticky align-middle"><div class="d-flex align-items-center justify-content-center">Fecha Consulta <a class="pointer text-success text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortDateASC('date')"></i><i class="las la-caret-down d-block arrow-short" @click="shortDateDESC('date')"></i></a></div></th>
                                <th v-if="column1 && consultantId == ''" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">Consultante <a class="pointer text-success text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortWordsDESC('clientName')"></i><i class="las la-caret-down d-block arrow-short" @click="shortWordsASC('clientName')"></i></a></div></th>
                                <th v-if="column20 && consultantId == ''" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">WhatsApp</div></th>
                                <th v-if="column21 && consultantId == ''" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">Mail</div></th>
                                <th v-if="column2" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">Publicación Contratada <a class="pointer text-success text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortWordsDESC('title')"></i><i class="las la-caret-down d-block arrow-short" @click="shortWordsASC('title')"></i></a></div></th> 
                                <th v-if="column3" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">Estado <a class="pointer text-success text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortWordsDESC('status')"></i><i class="las la-caret-down d-block arrow-short" @click="shortWordsASC('status')"></i></a></div></th>
                                <th v-if="column4" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">Opciones</div></th>
                                <th v-if="column5" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">Moneda </div></th>
                                <th v-if="column6" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">Monto Bruto <a class="pointer text-success text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortNumbersDESC('price')"></i><i class="las la-caret-down d-block arrow-short" @click="shortNumbersASC('price')"></i></a></div></th>
                                <th v-if="column7" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">Descuento <a class="pointer text-success text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortNumbersDESC('promoSeller')"></i><i class="las la-caret-down d-block arrow-short" @click="shortNumbersASC('promoSeller')"></i></a></div></th>
                                <th v-if="column8" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">Monto Final <a class="pointer text-success text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortNumbersDESC('createByProf')"></i><i class="las la-caret-down d-block arrow-short" @click="shortNumbersASC('netPrice')"></i></a></div></th>  
                                <th v-if="column9" class="text-center text-warning align-middle"><div class="d-flex align-items-center justify-content-center">Confirmación de cobro <a class="pointer text-warning text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortNumbersDESC('pay')"></i><i class="las la-caret-down d-block arrow-short" @click="shortNumbersASC('pay')"></i></a></div></th>
                                <th v-if="column10" class="text-center text-warning align-middle"><div class="d-flex align-items-center justify-content-center">Fecha Cobro <a class="pointer text-warning text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortDateASC('datePay')"></i><i class="las la-caret-down d-block arrow-short" @click="shortDateDESC('datePay')"></i></a></div></th>
                                <th v-if="column11" class="text-center text-warning align-middle"><div class="d-flex align-items-center justify-content-center">Deuda <a class="pointer text-warning text-decoration-none"><i class="las la-caret-up d-block arrow-short" @click="shortNumbersDESC('PendingPay')"></i><i class="las la-caret-down d-block arrow-short" @click="shortNumbersASC('PendingPay')"></i></a></div></th>          
                                <th v-if="country == 5" class="text-center text-warning align-middle"><div class="d-flex align-items-center justify-content-center">Facturación</div></th>          
                                <th class="bg-white shadow-none border-0" v-if="(title1 > 0 || title2 > 0) && (title3 > 0 || title4 > 0)"></th>
                                <th v-if="column12" class="text-center text-primary align-middle"><div class="d-flex align-items-center justify-content-center">% </div></th>
                                <th v-if="column13" class="text-center text-primary align-middle"><div class="d-flex align-items-center justify-content-center">Total Comisión </div></th>
                                <th v-if="column14" class="text-center text-info align-middle"><div class="d-flex align-items-center justify-content-center">Total a Cobrar </div></th>
                                <th v-if="column15" class="text-center text-info align-middle"><div class="d-flex align-items-center justify-content-center">Fecha </div></th>
                                <th v-if="column16" class="text-center text-info align-middle"><div class="d-flex align-items-center justify-content-center">Pendiente a cobrar </div></th>
                                <th class="bg-white shadow-none border-0" v-if="(title1 > 0 || title2 > 0 || title3 > 0 || title4 > 0) && (title5 > 0 || title6 > 0 || title7 > 0)"></th>
                                <th v-if="column17" class="text-center text-success align-middle"><div class="d-flex align-items-center justify-content-center">ID de contratación</div></th>
                                <th v-if="column18" class="text-center text-warning align-middle"><div class="d-flex align-items-center justify-content-center">ID de Pago </div></th>
                                <th v-if="column19" class="text-center text-info align-middle"><div class="d-flex align-items-center justify-content-center">ID de Deposito</div></th>
                            </tr>
                        </thead>
                        <tbody class="border-top-0">
                            <tr v-for="b in records" :key="b.id" :id="'tr-' + b.id" @click="active(b.id)" > 
                                <td :data-search-term="b.sellerName" class="sticky">
                                    <div class="d-flex align-items-center" style="width: 90px;"> 
                                        <span class="fw-bold m-1">{{b.date}}</span> 
                                    </div>   
                                </td>
                                <td v-if="column1 && consultantId == ''">
                                    <div class="d-flex align-items-center" style="width: 250px;"> 
                                        <div class="w-25 text-center">
                                            <img v-if="b.imgClient != '@/assets/imgs/user-img-small.png'" :src="b.imgClient" class="" height="20" width="20" >
                                            <img v-else src="@/assets/imgs/user-img-small-gradient.png" class="" height="20" width="20">
                                        </div>
                                        <span class="m-1">{{b.clientName}}</span> 
                                    </div>   
                                </td> 
                                <td v-if="column20 && consultantId == ''">
                                    <div class="d-flex align-items-center justify-content-center" style="width: 150px;"> 
                                        <span v-if="b.clientPhone != ''" class="m-1"><a :href="'https://wa.me/'+b.clientPhone" target="blank" class=""><i class="lab la-whatsapp"></i> {{b.clientPhone}}</a></span> 
                                        <span v-else>--</span>
                                    </div>   
                                </td>    
                                <td v-if="column21 && consultantId == ''">
                                    <div class="d-flex align-items-center justify-content-center" style="width: 250px;"> 
                                        <span class="m-1" v-if="b.clientMail != ''"><a :href="'mailto:'+b.clientMail" target="blank" class="">{{b.clientMail}}</a></span> 
                                        <span v-else>--</span>
                                    </div>   
                                </td>           
                                <td v-if="column2"><div style="width: 120px;"> {{b.title}}</div></td>
                                <td v-if="column3" class="text-center"><div style="width: 120px;"> {{b.modality}}</div></td>
                                <td v-if="column4" class="text-center">
                                    <span class="badge rounded-pill bg-primary pointer p-2" v-if="b.modeSell == '1'" @click="findBookings(b.id, b.modeSell)">Ver contratación</span>
                                    <span class="badge rounded-pill bg-primary pointer p-2" v-if="b.modeSell == '2' && b.moduleId == ''" @click="findBookings(b.id, b.modeSell)">Ver contratación</span>
                                    <span v-if="b.modeSell == '2' && b.moduleId != ''">--</span>
                                </td>
                                <td v-if="column5" class="text-center">{{b.currency}}</td>
                                <td v-if="column6" class="text-center">{{b.price}}</td>
                                <td v-if="column7" class="text-center">{{b.promoSeller}}</td>
                                <td v-if="column8" class="text-center">{{b.netPrice}}</td>
                                <td v-if="column9 && b.pay == 0 && b.complete != '2'" class="text-center" :id="'b-' + b.id"><span class="badge rounded-pill bg-success pointer p-2" @click="markPay(b.id, b.netPrice)">Marcar Paga</span></td>
                                <td v-if="column9 && b.pay == 0 && b.complete == '2'" class="text-center" :id="'b-' + b.id">NO</td>
                                <td v-if="column9 && b.pay == 1" class="text-center">SI</td>
                                <td v-if="column9 && b.pay == '--'" class="text-center">--</td>
                                <td v-if="column10" class="text-center">
                                    <div class="d-flex align-items-center justify-content-center" style="width: 90px;" :id="'f-' + b.id">  
                                        {{b.datePay}}
                                    </div>   
                                </td>
                                <td v-if="column11 && b.complete != '2'" class="text-center" :id="'d-' + b.id">{{b.PendingPay}}</td>
                                <td v-if="column11 && b.complete == '2' && b.pay == 0" class="text-center" :id="'d-' + b.id">0</td>
                                <td v-if="column11 && b.complete == '2' && b.pay != 0" class="text-center" :id="'d-' + b.id">0</td>
                                <td v-if="country == 5 && b.currency == 'ARS'" class="text-center" :id="'fac-' + b.id">
                                    <div v-if="!b.canBill && b.billLink != ''">
                                        <a :href="b.billLink" target="blank" class="text-primary">Ver Factura</a>
                                    </div>
                                    <div v-if="!b.canBill && b.billLink == ''"></div>
                                    <div v-if="b.canBill && b.billLink == ''">
                                        <span class="badge rounded-pill bg-success pointer p-2" @click="facturar(b.customerId, b.billDetails, b.billPrice, b.id, b.clientMail, b.obraSocial, b.numObraSocial)"><i class="las la-receipt"></i> Facturar</span>
                                    </div>
                                </td>
                                <td class="bg-white shadow-none border-0" v-if="(title1 > 0 || title2 > 0) && (title3 > 0 || title4 > 0)">
                                    <div style="width: 200px;"></div>
                                </td>
                                <td v-if="column12" class="text-center">
                                    <div class="d-flex align-items-center justify-content-center" style="width: 50px;">  
                                        {{b.comisionPorc}}
                                    </div> 
                                </td>
                                <td v-if="column13" class="text-center">
                                    <div class="d-flex align-items-center justify-content-center" style="min-width: 90px;">  
                                        {{b.AmmountAs}}
                                    </div> 
                                </td>
                                <td v-if="column14 && b.cashout_id != ''" class="text-center">
                                    <div class="d-flex align-items-center justify-content-center" style="min-width: 90px;" :id="'pp-' + b.id">  
                                        {{b.netPrice}}
                                    </div> 
                                </td>
                                <td v-if="column14 && b.cashout_id == ''" class="text-center">
                                    <div class="d-flex align-items-center justify-content-center" style="min-width: 90px;" :id="'pp-' + b.id">  
                                        0
                                    </div> 
                                </td>
                                <td v-if="column15" class="text-center">
                                    <div class="d-flex align-items-center justify-content-center" style="min-width: 90px;" :id="'ff-' + b.id">  
                                        {{b.payout_date}}
                                    </div> 
                                </td>
                                <td v-if="column16 && b.cashout_id == ''" class="text-center">
                                    <div class="d-flex align-items-center justify-content-center" style="min-width: 90px;" :id="'dd-' + b.id">  
                                        {{b.netPrice}}
                                    </div> 
                                </td>
                                <td v-if="column16 && b.cashout_id != ''" class="text-center">
                                    <div class="d-flex align-items-center justify-content-center" style="min-width: 90px;" :id="'dd-' + b.id">  
                                        0
                                    </div> 
                                </td>
                                <td class="bg-white shadow-none border-0" v-if="(title1 > 0 || title2 > 0 || title3 > 0 || title4 > 0) && (title5 > 0 || title6 > 0 || title7 > 0)">
                                    <div style="width: 200px;"></div>
                                </td>
                                <td v-if="column17" class="text-center">{{b.sellId}}</td>
                                <td v-if="column18" class="text-center" :id="'p-' + b.id">{{b.payId}}</td>
                                <td v-if="column19" class="text-center">{{b.cashout_id}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tableSearch shadow">
                    <div class="input-group form-password-toggle me-2">   
                        <input type="text" class="form-control" :placeholder="placeholder" v-model="textSearch" @keyup="findinArray()" >
                        <span class="input-group-text cursor-pointer"><i class="las la-search" @change="findinArray()"></i></span>
                    </div>
                    <div>
                        <button type="button" class="btn btn-sm hide-arrow py-0 waves-effect waves-float waves-light p-0" @click="maximize()" title="Maximizar o minimizar tabla">
                            <i class="las fs-30 text-blue" :class="spandIcon"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <booking-menu v-if="bookingId != '' && typeSell == '1'" :userId="dataReceiver" userType="1" :localZone="localZone" :bookingId="bookingId"></booking-menu>
    <course-menu v-if="bookingId != '' && typeSell == '2'" :userId="dataReceiver" userType="1" :localZone="localZone" :bookingId="bookingId"></course-menu>
    <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 11000; width: fit-content; margin-bottom: 50px;">
        <div id="toastcontainer2" class="w-25">
        </div>
    </div>
    <div class="modal fade" id="modalBill" tabindex="-1" aria-labelledby="" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" ref="modalBill">
        <div class="modal-dialog">
            <div class="modal-content shadow">
                <div class="modal-header">
                    <h5 class="modal-title"><i class="las la-receipt text-primary"></i> Emitir Factura</h5> 
                    <button type="button" class="btn-close" @click="closePopUp()"></button>
                </div>
                <div class="modal-body facuracion">
                    <div class="text-dark">
                        <form-afip-data v-if="userSelected != ''" :userSelected="dataReceiver" :userMode="2" :generateKey="false" textButton="Facturar" :refContact="userSelected" :bill="true" :billDetails="billDetails" :billPrice="billPrice" :bookingId="billBookId" :userMail="userBillMail" :obraSocial="obraSocial" :numObraSocial="numObraSocial"></form-afip-data>
                    </div>  
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
import axios from "axios";
import { Toast } from 'bootstrap';
import { Modal } from "bootstrap";
import bookingMenu from '@/components/bookings/booking-menu.vue'
import courseMenu from '@/components/bookings/course-menu.vue'
import formAfipData from '@/components/my-account/form-afip-data.vue'
export default {  
    props: ['result', 'dataReceiver', 'modeSell', 'placeholder', 'consultantId', 'sticky'],
    name: "professionals-records-sales",
    components: {
        bookingMenu,
        courseMenu,
        formAfipData
    },
    data(){
        return{
            userSelected: '',
            billDetails: '',
            billPrice: '',
            billBookId: '',
            userBillMail: '',
            obraSocial: '',
            numObraSocial: '',
            country: 0,
            fixedfullscreen: '',
            spandIcon: 'la-expand-arrows-alt',
            column1: true,
            column2: true,
            column3: true,
            column4: true,
            column5: true,
            column6: true,
            column7: true,
            column8: true,
            column9: true,
            column10: true,
            column11: true,
            column12: true,
            column13: true,
            column14: true,
            column15: true,
            column16: true,
            column17: true,
            column18: true,
            column19: true,
            column20: true,
            column21: true,
            title1: 10,
            title2: 3,
            title3: 2,
            title4: 3,
            title5: 1,
            title6: 1,
            title7: 1,
            textSearch: '',
            records: [],
            recordsBkp: [],
            bookingId: '',
            localZone: '',
            typeSell: '',
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            columnsArray: {
                column1: true,
                column2: true,
                column3: true,
                column4: true,
                column5: true,
                column6: true,
                column7: true,
                column8: true,
                column9: true,
                column10: true,
                column11: true,
                column12: true,
                column13: true,
                column14: true,
                column15: true,
                column16: true,
                column17: true,
                column18: true,
                column19: true,
                column20: false,
                column21: false,
            }
        }
    },
    computed: {
        billingExport() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('billingExport');
            }
            return show
        },
        invoice() {
            var show = true;
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                show = this.$root.corporatePermissions('invoice');
            }
            return show
        },
    },
    mounted: function () {

        if(localStorage.getItem('token')){
            if(localStorage.getItem('token') != ''){
                var data = JSON.parse(localStorage.getItem('userData'));
                if(data.userType == 1){
                    this.country = data.userCountry;
                }
            }
        } 
    const ele = document.querySelector('.table-responsive');
    ele.style.cursor = 'grab';

    let pos = { top: 0, left: 0, x: 0, y: 0 };

    const mouseDownHandler = function (e) {
        ele.style.cursor = 'grabbing';
        ele.style.userSelect = 'none';

        pos = {
            left: ele.scrollLeft,
            top: ele.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY,
        };

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
    };

    const mouseMoveHandler = function (e) {
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        // Scroll the element
        ele.scrollTop = pos.top - dy;
        ele.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function () {
        ele.style.cursor = 'grab';
        ele.style.removeProperty('user-select');

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
    };

    // Attach the handler
    ele.addEventListener('mousedown', mouseDownHandler);


        if(this.consultantId != ''){
            this.title1 = 7;
        }
        if(localStorage.getItem('billColumns')){
            if(localStorage.getItem('billColumns') != ''){
                this.updateColums(); 
            }
        }
        var element =  document.getElementById('momentScript');
        if (typeof(element) != 'undefined' && element != null){
            this.localZone =  moment.tz.guess();          
        }else{       
            const plugin = document.createElement("script");
            plugin.setAttribute("src", "https://cdn.jsdelivr.net/npm/moment@2.27.0/min/moment.min.js");
            plugin.async = false;
            document.head.appendChild(plugin);
            const plugin2 = document.createElement("script");
            plugin2.setAttribute("src", "https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.5.34/moment-timezone-with-data-10-year-range.js");
            plugin2.async = false;
            document.head.appendChild(plugin2);
            plugin.onload = () => {
                plugin2.onload = () => {
                    this.localZone =  moment.tz.guess();    
                }
            } 
        } 
        this.load();

       
        
    },
    methods:{
        async facturar(val, concepto, precio, bookingId, userMail, obraSocial, numObraSocial){
            if(!this.invoice){
                alert('No tienes permisos suficientes para emitir facturas.');
                return
            }
            this.userSelected = val;
            this.billDetails = concepto;
            this.billPrice = precio;
            this.billBookId = bookingId;
            this.userBillMail = userMail;
            this.obraSocial = obraSocial;
            this.numObraSocial = numObraSocial;
            try{
                var modal = new Modal(document.querySelector('#modalBill')) 
                modal.show();
                this.modal = modal;
                document.querySelector('.modal-backdrop').style.display = 'none';
            }catch(e){
                console.log(e)
            }
        },
        active(val){
            var elems = document.querySelectorAll(".activeTr");
            [].forEach.call(elems, function(el) {
                el.classList.remove("activeTr");
            });
            try{
                document.querySelector('#tr-'+val).classList.add('activeTr');
            }catch(e){

            }    
        },
        load(){  
            console.log(this.result)
            this.records = this.result;  
            this.recordsBkp = this.records;
        },
        updateColums(){
            var data = JSON.parse(localStorage.getItem('billColumns'));
            this.column1 = data.column1;
            this.column2 = data.column2;
            this.column3 = data.column3;
            this.column4 = data.column4;
            this.column5 = data.column5;
            this.column6 = data.column6;
            this.column7 = data.column7;
            this.column8 = data.column8;
            this.column9 = data.column9;
            this.column10 = data.column10;
            this.column11 = data.column11;
            this.column12 = data.column12;
            this.column13 = data.column13;
            this.column14 = data.column14;
            this.column15 = data.column15;
            this.column16 = data.column16;
            this.column17 = data.column17;
            this.column18 = data.column18;
            this.column19 = data.column19;
            this.column20 = data.column20;
            this.column21 = data.column21;
            if(!this.column1){
                this.title1--;
            }
            if(!this.column2){
                this.title1--;
            }
            if(!this.column3){
                this.title1--;
            }
            if(!this.column4){
                this.title1--;
            }
            if(!this.column5){
                this.title1--;
            }
            if(!this.column6){
                this.title1--;
            }
            if(!this.column7){
                this.title1--;
            }
            if(!this.column8){
                this.title1--;
            }
            if(!this.column20){
                this.title1--;
            }
            if(!this.column21){
                this.title1--;
            }
            if(!this.column9){
                this.title2--;
            }
            if(!this.column10){
                this.title2--;
            }
            if(!this.column11){
                this.title2--;
            }
            if(!this.column12){
                this.title3--;
            }
            if(!this.column13){
                this.title3--;
            }
            if(!this.column14){
                this.title4--;
            }
            if(!this.column15){
                this.title4--;
            }
            if(!this.column16){
                this.title4--;
            }
            if(!this.column17){
                this.title5--;
            }
            if(!this.column18){
                this.title6--;
            }
            if(!this.column19){
                this.title7--;
            }
        },
        async markPay(val, price){
            var answer = confirm('Acepta para marcarla como paga y dejaremos de enviarle recordatorios de pago a esta persona.');
	        if (answer){   
                var payload = {
                    action: 'mark-pay-booking',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    ref: val
                }
                this.hideNotFound = true;
                await axios.post('/index.php', payload).then(result => {
                    var objIndex  = this.records.findIndex(obj => obj.id == val);
                    var objIndexBkp  = this.recordsBkp.findIndex(obj => obj.id == val);
                    this.records[objIndex].pay = 1;
                    this.recordsBkp[objIndexBkp].pay = 1;
                    this.records[objIndex].datePay = result.data.date;
                    this.recordsBkp[objIndexBkp].datePay = result.data.date;
                    this.records[objIndex].PendingPay = 0;
                    this.recordsBkp[objIndexBkp].PendingPay = 0;
                    this.records[objIndex].payId = result.data.payId;
                    this.recordsBkp[objIndexBkp].payId = result.data.payId;
                    this.records[objIndex].netPrice = price;
                    this.recordsBkp[objIndexBkp].netPrice = price;

                    try{
                        document.querySelector('#b-' + val).innerHTML = 'SI';
                    }catch(e){

                    }
                    try{
                        document.querySelector('#f-' + val).innerHTML = result.data.date;
                    }catch(e){

                    }
                    try{
                        document.querySelector('#d-' + val).innerHTML = 0;
                    }catch(e){

                    }
                    try{
                        document.querySelector('#p-' + val).innerHTML = result.data.payId;
                    }catch(e){

                    }
                    try{
                        document.querySelector('#pp-' + val).innerHTML = price;
                    }catch(e){

                    }
                    try{
                        document.querySelector('#dd-' + val).innerHTML = 0;
                    }catch(e){

                    }
                    try{
                        document.querySelector('#ff-' + val).innerHTML = '--';
                    }catch(e){

                    }

                    if(this.$route.name == 'billing'){
                        this.$parent.listBilling();
                    }
                    this.errorText = 'La contratación cambio al estado de abonada.';
                    this.toastBg = 'bg-info';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it    
                    }catch(e){

                    }		  
                })
                .catch(error => {
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }   
                    return;
                })
            }
        },
        closeOptions(){
            this.bookingId = '';
            this.typeSell = '';
            if(document.getElementsByClassName('fixed-full-screen').length == 0){
                try{
                    document.querySelector('html').style.overflow = "auto";
                }catch(e){

                }
            }  
        }, 
        findBookings(val, type){ 
            try{
                document.querySelector('html').style.setProperty('overflow', 'hidden' , "important");
            }catch(e){

            }
            this.typeSell = type;
            this.bookingId = val;  
        },
        shortDateASC(val){
            if(val == 'date'){
                this.records.sort((a, b) => Number(new Date(b.dateBookingNoFormat)) - Number(new Date(a.dateBookingNoFormat)));
            }    
            if(val == 'datePay'){
                this.records.sort((a, b) => Number(new Date(b.payDateNoFormat)) - Number(new Date(a.payDateNoFormat)));
            }  
            if(val == 'payout_date'){
                this.records.sort((a, b) => Number(new Date(b.datePaidNoFormat)) - Number(new Date(a.datePaidNoFormat)));
            }    
        },
        shortDateDESC(val){
            if(val == 'date'){
                this.records.sort((a, b) => Number(new Date(a.dateBookingNoFormat)) - Number(new Date(b.dateBookingNoFormat)));
            }    
            if(val == 'datePay'){
                this.records.sort((a, b) => Number(new Date(a.payDateNoFormat)) - Number(new Date(b.payDateNoFormat)));
            }   
            if(val == 'payout_date'){
                this.records.sort((a, b) => Number(new Date(a.datePaidNoFormat)) - Number(new Date(b.datePaidNoFormat)));
            }    
        },
        shortNumbersASC(val){
            // sort by value
            if(val == 'price'){
                this.records.sort((a, b) => a.price - b.price);
            }
            if(val == 'promoSeller'){
                this.records.sort((a, b) => a.promoSeller - b.promoSeller);
            }
            if(val == 'netPrice'){
                this.records.sort((a, b) => a.netPrice - b.netPrice);
            }
            if(val == 'pay'){
                this.records.sort((a, b) => a.pay - b.pay);
            }
            if(val == 'PendingPay'){
                this.records.sort((a, b) => parseFloat(a.PendingPay) - parseFloat(b.PendingPay));
            }
        },
        shortNumbersDESC(val){
            // sort by value
            if(val == 'price'){
                this.records.sort((a, b) => b.price - a.price);
            }
            if(val == 'promoSeller'){
                this.records.sort((a, b) => b.promoSeller - a.promoSeller);
            }
            if(val == 'netPrice'){
                this.records.sort((a, b) => b.netPrice - a.netPrice);
            }
            if(val == 'pay'){
                this.records.sort((a, b) => b.pay - a.pay);
            }
            if(val == 'PendingPay'){
                this.records.sort((a, b) => parseFloat(b.PendingPay) - parseFloat(a.PendingPay));
            }
        },


        shortWordsASC(val){
            // sort by name
            this.records.sort((a, b) => {
                let nameA;
                let nameB;
            
            if(val == 'clientName'){
                nameA = a.clientName.toUpperCase(); // ignore upper and lowercase
                nameB = b.clientName.toUpperCase(); // ignore upper and lowercase
            }
            if(val == 'title'){
                nameA = a.title.toUpperCase(); // ignore upper and lowercase
                nameB = b.title.toUpperCase(); // ignore upper and lowercase
            }
            if(val == 'status'){
                nameA = a.modality.toUpperCase(); // ignore upper and lowercase
                nameB = b.modality.toUpperCase(); // ignore upper and lowercase
            } 
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            // names must be equal
            return 0;
            });

        },
        shortWordsDESC(val){
            // sort by name
            this.records.sort((a, b) => {
                let nameA;
                let nameB;
            
            if(val == 'clientName'){
                nameA = a.clientName.toUpperCase(); // ignore upper and lowercase
                nameB = b.clientName.toUpperCase(); // ignore upper and lowercase
            }
            if(val == 'title'){
                nameA = a.title.toUpperCase(); // ignore upper and lowercase
                nameB = b.title.toUpperCase(); // ignore upper and lowercase
            }
            if(val == 'status'){
                nameA = a.modality.toUpperCase(); // ignore upper and lowercase
                nameB = b.modality.toUpperCase(); // ignore upper and lowercase
            }  
            if (nameA > nameB) {
                return -1;
            }
            if (nameA < nameB) {
                return 1;
            }

            // names must be equal
            return 0;
            });
        },
        findinArray(){
            var scrollDiv = document.querySelector(".container-tabs").offsetTop;
            window.scrollTo({ top: scrollDiv - 50, behavior: 'smooth'});

            var matches = this.recordsBkp;
            this.records = matches.filter(
                s => s.modality.toLowerCase().includes(this.textSearch.toLowerCase()) 
                || s.clientName.toLowerCase().includes(this.textSearch.toLowerCase())
                || s.title.toLowerCase().includes(this.textSearch.toLowerCase())
                || s.service.toLowerCase().includes(this.textSearch.toLowerCase())
                || s.sellId.toLowerCase().includes(this.textSearch.toLowerCase())
                || s.payId.toLowerCase().includes(this.textSearch.toLowerCase())
                || s.cashout_id.toLowerCase().includes(this.textSearch.toLowerCase())
                || s.date.toLowerCase().includes(this.textSearch.toLowerCase())
            );
        },
        maximize(){
            if(this.fixedfullscreen == ""){
                this.fixedfullscreen = "fixed-full-screen";
                this.spandIcon = "la-compress-arrows-alt";
                document.querySelector('html').setAttribute('style', 'overflow: hidden !important');
            }else{
                this.fixedfullscreen = "";
                this.spandIcon = "la-expand-arrows-alt";
                document.querySelector('html').setAttribute('style', '');
            }
        },
        showHideColum(val){
            if(val == 1){
                if(this.column1 == true){
                    this.column1 = false;
                    this.title1--;
                }else{
                    this.column1 = true;
                    this.title1++;
                }
            }else if(val == 2){
                if(this.column2 == true){
                    this.column2 = false;
                    this.title1--;
                }else{
                    this.column2 = true;
                    this.title1++;
                }
            }else if(val == 3){
                if(this.column3 == true){
                    this.column3 = false;
                    this.title1--;
                }else{
                    this.column3 = true;
                    this.title1++;
                }
            }else if(val == 4){
                if(this.column4 == true){
                    this.column4 = false;
                    this.title1--;
                }else{
                    this.column4 = true;
                    this.title1++;
                }
            }else if(val == 5){
                if(this.column5 == true){
                    this.column5 = false;
                    this.title1--;
                }else{
                    this.column5 = true;
                    this.title1++;
                }
            }else if(val == 6){
                if(this.column6 == true){
                    this.column6 = false;
                    this.title1--;
                }else{
                    this.column6 = true;
                    this.title1++;
                }
            }else if(val == 7){
                if(this.column7 == true){
                    this.column7 = false;
                    this.title1--;
                }else{
                    this.column7 = true;
                    this.title1++;
                }
            }else if(val == 8){
                if(this.column8 == true){
                    this.column8 = false;
                    this.title1--;
                }else{
                    this.column8 = true;
                    this.title1++;
                }
            }else if(val == 20){
                if(this.column20 == true){
                    this.column20 = false;
                    this.title1--;
                }else{
                    this.column20 = true;
                    this.title1++;
                }
            }else if(val == 21){
                if(this.column21 == true){
                    this.column21 = false;
                    this.title1--;
                }else{
                    this.column21 = true;
                    this.title1++;
                }
            }else if(val == 9){
                if(this.column9 == true){
                    this.column9 = false;
                    this.title2--;
                }else{
                    this.column9 = true;
                    this.title2++;
                }
            }else if(val == 10){
                if(this.column10 == true){
                    this.column10 = false;
                    this.title2--;
                }else{
                    this.column10 = true;
                    this.title2++;
                }
            }else if(val == 11){
                if(this.column11 == true){
                    this.column11 = false;
                    this.title2--;
                }else{
                    this.column11 = true;
                    this.title2++;
                }
            }else if(val == 12){
                if(this.column12 == true){
                    this.column12 = false;
                    this.title3--;
                }else{
                    this.column12 = true;
                    this.title3++;
                }
            }else if(val == 13){
                if(this.column13 == true){
                    this.column13 = false;
                    this.title3--;
                }else{
                    this.column13 = true;
                    this.title3++;
                }
            }else if(val == 14){
                if(this.column14 == true){
                    this.column14 = false;
                    this.title4--;
                }else{
                    this.column14 = true;
                    this.title4++;
                }
            }else if(val == 15){
                if(this.column15 == true){
                    this.column15 = false;
                    this.title4--;
                }else{
                    this.column15 = true;
                    this.title4++;
                }
            }else if(val == 16){
                if(this.column16 == true){
                    this.column16 = false;
                    this.title4--;
                }else{
                    this.column16 = true;
                    this.title4++;
                }
            }else if(val == 17){
                if(this.column17 == true){
                    this.column17 = false;
                    this.title5--;
                }else{
                    this.column17 = true;
                    this.title5++;
                }
            }else if(val == 18){
                if(this.column18 == true){
                    this.column18 = false;
                    this.title6--;
                }else{
                    this.column18 = true;
                    this.title6++;
                }
            }else if(val == 19){
                if(this.column19 == true){
                    this.column19 = false;
                    this.title7--;
                }else{
                    this.column19 = true;
                    this.title7++;
                }
            }
            this.columnsArray = {
                column1: this.column1,
                column2: this.column2,
                column3: this.column3,
                column4: this.column4,
                column5: this.column5,
                column6: this.column6,
                column7: this.column7,
                column8: this.column8,
                column9: this.column9,
                column10: this.column10,
                column11: this.column11,
                column12: this.column12,
                column13: this.column13,
                column14: this.column14,
                column15: this.column15,
                column16: this.column16,
                column17: this.column17,
                column18: this.column18,
                column19: this.column19,
                column20: this.column20,
                column21: this.column21,
            }

            localStorage.setItem('billColumns', JSON.stringify(this.columnsArray));
        },
        async exportOption(){
            var payload = {
                action: 'find-billing-all',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver,
                mode: 1, 
                export: true,
                timezone: this.localZone,
                exportArray: this.records
            } 
            await axios.post('/index.php', payload).then(result => {      
                if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
                    this.download('https://api.animasana.net' + result.data.file, 'nombre.xlsx');  
                }else if(window.location.host == 'api-qa.animasana.net'){
                    this.download('https://api-qa.animasana.net' + result.data.file, 'nombre.xlsx');  
                }else{
                    this.download('https://api-qa.animasana.net' + result.data.file, 'nombre.xlsx'); 
                }
            })
           
        },
        download(dataurl, filename) {
            const link = document.createElement("a");
            link.href = dataurl;
            link.download = filename;
            link.click();
        },
        updateInvoice(id, link){
            try{
                document.querySelector('#fac-' + id).innerHTML = '<a href="'+link+'" target="blank" class="text-primary">Ver Factura</a>';
            }catch(e){

            }
            this.errorText = 'Factura Generada';
            this.toastBg = 'bg-success';
            this.toastColor = 'text-dark';
            this.toastNumber++;
            var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
            try{
                document.querySelector('#toastcontainer2').insertAdjacentHTML("afterend", t);
                var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                var bsAlert = new Toast(myAlert);//inizialize it
                bsAlert.show();//show it
            }catch(e){

            }	   
        },
        closePopUp(){ 
            this.modal.hide();
            this.userSelected = '';
            this.billDetails = '';
            this.billPrice = '';
            this.billBookId = '';
            this.userBillMail = '';
            this.obraSocial = '';
            this.numObraSocial = '';
        }
    }
}
</script>
<style scoped>
#basic-table table{
    font-size: 12px;
}
th.bg-my[data-v-1f323969] {
    position: sticky;
    left: 0px;
    z-index: 2;
}
.tableSearch{
    position: fixed;
    z-index: 36;
    bottom: 82px;
    width: 40%;
    background: #f3f3f3;
    padding: 10px;
    margin: auto;
    border-radius: 5px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
}
.sticky .tableSearch{
    position: sticky;
    bottom: 70px;
    width: 79%;
}
.fixed-full-screen .tableSearch{
    position: fixed;
    bottom: 48px;
    left: 0;
    right: 0;
}
.sticky .fixed-full-screen .tableSearch{
    position: sticky;
    width: 95%;
    bottom: 0;
}
.dropdown-menu-end{
    width: 488px;
    inset: 0px auto auto 0px !important;
    transform: translate3d(0px, 26px, 0px) !important;
}

@media (max-width: 600px) {
    .tableSearch{
        width: 95%;
    }
    .dropdown-menu-end{
        width: 250px;
        z-index: 200;
        inset: 0px auto auto 0px !important;
        transform: translate3d(0px, 26px, 0px) !important;
    }
}

th.bg-my{
    position:sticky;
  left:0px;
  z-index: 2;
}
td.sticky
{
  position:sticky;
  left:0px;
  z-index: 2;
  background: #fff;
}

tr.sticky:not(caption) > *{
    box-shadow: inset 0 0 0 9999px #545454;
}

.dark-layout tr.sticky:not(caption) > *{
    box-shadow: inset 0 0 0 9999px #545454;
}

.fixed-full-screen{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    padding: 5px;
    width: 100%;
    height: 100%;
    background: #f7f7f7;
    right: 0;
    padding: 10px;
}
@media (max-width: 600px) {
.sticky .fixed-full-screen{
    height: calc(100% - 65px);
}
}

.pointer{
    cursor: pointer;
}
.fixed-head-table{
    position: sticky;
    top: 0;
    background: #f3f3f3;
    z-index: 24;
    border: 1px;
}

.arrow-short{
    margin-left: 10px;
}
.fs-30{
    font-size: 30px;
}
.container-overlay{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(34, 41, 47, 0.5);
    cursor: pointer;
    transition: all 0.7s, z-index 0s;
    z-index: 16;
}

.dark-layout .container-half-v{
    background: #f3f3f3;
}

.container-half-v{
    width: 50%;
    height: 100%;
    overflow: auto;
    position: fixed;
    z-index: 84;
    top: 0;
    right: 0;
    bottom: 0;
    background: #f3f3f3;
}
@media (max-width: 600px) {
    .container-half-v{
        width: 100%;
    }
}
.container-half-v .close {
    font-size: 30px;
    position: fixed;
    z-index: 2;
    right: 22px;
    top: 11px;
    color: #7367f0;
    cursor: pointer;
}
.bg-light-primary {
    background: rgba(115, 103, 240, .12) !important;
    color: #7367f0 !important;
    border: 1px;
}
.bg-light-success {
    background: rgba(40, 199, 111, .12) !important;
    color: #28c76f !important;
    border: 1px;
}
.bg-light-warning {
    background: rgba(255, 159, 67, .12) !important;
    color: #ff9f43 !important;
    border: 1px;
}
.bg-light-info {
    background: rgba(0, 207, 232, .12) !important;
    color: #00cfe8 !important;
    border: 1px;
}
.table tfoot tr th, .table thead tr th {
    background-color: #f3f3f3;
    color: #d0d2d6;
    border: 1px;
}
table tr.activeTr td, table tr.activeTr td.sticky{
    background: #004193 !important;
    color: #fff !important;
}
#modalBill{
    z-index: 12000; 
    height: 80%; 
    overflow: hidden;
}
.modal-body.facuracion{
    overflow: auto; 
    height: calc(80vh - 203px);
}
@media (max-width: 600px) {
    #modalBill{
        z-index: 12000; 
        height: 100%; 
        overflow: hidden;
    }
    .modal-body.facuracion{
        overflow: auto; 
        height: calc(61vh - -51px);
    }
}
.activeTr .text-primary{
    color: #fff !important;
}
</style>